export default {
    // 中
    zhCN: {
        vin: 'VIN',
        name_of_maintenance_station: '维修站名称',
        mileage: '里程数',
        controller_name: '控制器名称',
        function_name: '功能',
        time: '时间',
        function_execution_result: '功能执行结果',
        channel: '通道',
        hardware_number: '硬件号',
        written_software_information: '写入的软件信息',
        software_information_before_refresh: '刷新前的软件信息',
        updated_software_information: '刷新后的软件信息',
    },
    // 英
    enUS: {
        vin: 'VIN',
        name_of_maintenance_station: 'Name of service station',
        mileage: 'Mileage',
        controller_name: 'Controller name',
        function_name: 'Function',
        time: 'Date',
        function_execution_result: 'Function execution result',
        channel: 'Channel',
        hardware_number: 'Hardware number',
        written_software_information: 'Written software information',
        software_information_before_refresh: 'Software information before refresh',
        updated_software_information: 'Updated software information',
    },
    // 德
    deDE: {
        vin: 'VIN',
        name_of_maintenance_station: 'Name der Service-Station',
        mileage: 'Kilometerstand',
        controller_name: 'Controller-Name',
        function_name: 'Funktionsname',
        time: 'Zeit',
        function_execution_result: 'Ergebnis der Funktionsausführung',
        channel: 'Kanal',
        hardware_number: 'Hardware-Nummer',
        written_software_information: 'Geschriebene Software-Informationen',
        software_information_before_refresh: 'Software-Informationen vor der Aktualisierung',
        updated_software_information: 'Aktualisierte Software-Informationen',
    },
    // 法
    frFR: {
        vin: 'VIN',
        name_of_maintenance_station: 'Nom de la station service',
        mileage: 'Kilométrage',
        controller_name: 'Nom du contrôleur',
        function_name: 'Fonction',
        time: 'Date',
        function_execution_result: 'Résultat',
        channel: 'Chaîne',
        hardware_number: 'Numéro de matériel',
        written_software_information: 'Informations écriture logiciel',
        software_information_before_refresh: 'Informations logiciel avant rafraichissement',
        updated_software_information: 'Informations mise à jour logiciel',
    },
    // 意大利
    itIT: {
        vin: 'VIN',
        name_of_maintenance_station: 'Nome stazione di assistenza',
        mileage: 'Chilometraggio',
        controller_name: 'Nome controllore',
        function_name: 'Funzione',
        time: 'Tempo',
        function_execution_result: 'Risultato esecuzione funzione',
        channel: 'Canale',
        hardware_number: 'Numero hardware',
        written_software_information: 'Informazioni software scritte',
        software_information_before_refresh: 'Informazioni software prima del refresh',
        updated_software_information: 'Informazioni software aggiornate',
    },
    // 荷兰
    nlNL: {
        vin: 'VIN',
        name_of_maintenance_station: 'Naam van de onderhoudsstation',
        mileage: 'Kilometerstand',
        controller_name: 'Controller naam',
        function_name: 'Functienaam',
        time: 'Tijd',
        function_execution_result: 'Functie uitvoeringsresultaat',
        channel: 'Kanaal',
        hardware_number: 'Hardware nummer',
        written_software_information: 'Geschreven software informatie',
        software_information_before_refresh: 'Software informatie voor update',
        updated_software_information: 'Geüpdatete software informatie',
    },
    // 越南
    viVN: {
        vin: 'Số khung',
        name_of_maintenance_station: 'Tên trạm dịch vụ',
        mileage: 'Số km đã đi',
        controller_name: 'Tên bộ phận điều khiển',
        function_name: 'Chức năng',
        time: 'Ngày',
        function_execution_result: 'Kết quả thực thi chức năng',
        channel: 'Kênh',
        hardware_number: 'Số phần cứng',
        written_software_information: 'Thông tin phần mềm đã viết',
        software_information_before_refresh: 'Thông tin phần mềm trước khi chạy lại',
        updated_software_information: 'Thông tin phần mềm được cập nhật',
    },
    // 西班牙
    esES: {
        vin: 'VIN',
        name_of_maintenance_station: 'Nombre de la estación de reparación',
        mileage: 'Kilometraje',
        controller_name: 'Nombre del controlador',
        function_name: 'Función',
        time: 'Tiempo',
        function_execution_result: 'Resultado de ejecución de la función',
        channel: 'Canal',
        hardware_number: 'Número de hardware',
        written_software_information: 'Información de software escrita',
        software_information_before_refresh: 'Información de software antes de la actualización',
        updated_software_information: 'Información de actualización de software',
    },
    // 葡萄牙
    ptBR: {
        vin: 'VIN',
        name_of_maintenance_station: 'Nome da estação de manutenção',
        mileage: 'Quilometragem',
        controller_name: 'Nome do controlador',
        function_name: 'Função',
        time: 'Tempo',
        function_execution_result: 'Resultado da execução da função',
        channel: 'Canal',
        hardware_number: 'Número do hardware',
        written_software_information: 'Informações do software gravado',
        software_information_before_refresh: 'Informações do software antes da atualização',
        updated_software_information: 'Informações do software atualizadas',
    },
    // 波兰
    plPL: {
        vin: 'VIN',
        name_of_maintenance_station: 'Nazwa stacji obsługi',
        mileage: 'Przebieg',
        controller_name: 'Nazwa kontrolera',
        function_name: 'Funkcja',
        time: 'Data',
        function_execution_result: 'Wynik wykonania funkcji',
        channel: 'Kanał',
        hardware_number: 'Sprzęt',
        written_software_information: 'Informacje o oprogramowaniu',
        software_information_before_refresh: 'Informacje o oprogramowaniu przed aktualizacją',
        updated_software_information: 'Informacje o oprogramowaniu po aktualizacji',
    },
    // 土耳其
    trTR: {
        vin: 'VIN',
        name_of_maintenance_station: 'Servis istasyonunun adı',
        mileage: 'Km',
        controller_name: 'Kontrol edn kişinin  ismi',
        function_name: 'Fonksiyon',
        time: 'Tarih',
        function_execution_result: 'Funksiyon çalışma sonuçları',
        channel: 'Kanal',
        hardware_number: 'Hardware numarası',
        written_software_information: 'Yazılmış yazılım bilgisi',
        software_information_before_refresh: 'Yeniden yenilenmeden önce yazılım bilgisi',
        updated_software_information: 'Yazılım bilgisi yenilenmiş',
    },
    // 捷克语
    csCZ: {
        vin: 'VIN',
        name_of_maintenance_station: 'Název servisu',
        mileage: 'Počet najetých kilometrů',
        controller_name: 'Název ovladače',
        function_name: 'Funkce',
        time: 'datum',
        function_execution_result: 'Výsledek provedení funkce',
        channel: 'Kanál',
        hardware_number: 'Číslo hardwaru',
        written_software_information: 'Psané informace o softwaru',
        software_information_before_refresh: 'Informace o softwaru před obnovením',
        updated_software_information: 'Aktualizované informace o softwaru',
    },
    // 匈牙利语
    huHU: {
        vin: 'Alvázszám',
        name_of_maintenance_station: 'Szervizállomás neve',
        mileage: 'Futásteljesítmény',
        controller_name: 'Vezérlő neve',
        function_name: 'Funkció',
        time: 'Dátum',
        function_execution_result: 'Funkcióvégrehajtási eredmény',
        channel: 'Csatorna',
        hardware_number: 'Hardver száma',
        written_software_information: 'Írásos szoftveradatok',
        software_information_before_refresh: 'Szoftveradatok frissítés előtt',
        updated_software_information: 'Frissített szoftveradatok',
    },
    // 俄罗斯语
    ruRU: {
        vin: 'VIN',
        name_of_maintenance_station: 'Название сервисной станции',
        mileage: 'Пробег',
        controller_name: 'Имя контроллера',
        function_name: 'Функция',
        time: 'Дата',
        function_execution_result: 'Результат выполнения функции',
        channel: 'Канал',
        hardware_number: 'Номер оборудования',
        written_software_information: 'Информация о программном обеспечении',
        software_information_before_refresh: 'Информация о программном обеспечении до обновления',
        updated_software_information: 'Обновленная информация о программном обеспечении',
    },
    // 沙特阿拉伯
    arSA: {
        vin: 'VIN',
        name_of_maintenance_station: 'اسم محطة الصيانة',
        mileage: 'عدد الكيلومترات',
        controller_name: 'اسم وحدة التحكم',
        function_name: 'الوظيفة',
        time: 'الوقت',
        function_execution_result: 'نتيجة تنفيذ الوظيفة',
        channel: 'القناة',
        hardware_number: 'رقم الجهاز',
        written_software_information: 'معلومات البرنامج المكتوبة',
        software_information_before_refresh: 'معلومات البرنامج قبل التحديث',
        updated_software_information: 'معلومات البرنامج بعد التحديث',
    },
    // 保加利亚
    bgBG: {
        vin: 'VIN',
        name_of_maintenance_station: 'Име на сервизна станция',
        mileage: 'Пробег',
        controller_name: 'Име на контролер',
        function_name: 'Функция',
        time: 'Време',
        function_execution_result: 'Резултат от изпълнението на функцията',
        channel: 'Канал',
        hardware_number: 'Хардуерен номер',
        written_software_information: 'Записана софтуерна информация',
        software_information_before_refresh: 'Софтуерна информация преди обновяване',
        updated_software_information: 'Софтуерна информация след обновяване',
    },
    // 丹麦语
    daDK: {
        vin: 'VIN',
        name_of_maintenance_station: 'Værkstedets navn',
        mileage: 'Kilometertal',
        controller_name: 'Styringsenhedens navn',
        function_name: 'Funktion',
        time: 'Tid',
        function_execution_result: 'Resultat af funktionsudførelse',
        channel: 'Kanal',
        hardware_number: 'Hardwarenummer',
        written_software_information: 'Skrivet softwareinformation',
        software_information_before_refresh: 'Softwareinformation før opdatering',
        updated_software_information: 'Opdateret softwareinformation',
    },
    // 芬兰语
    fiFI: {
        vin: 'VIN',
        name_of_maintenance_station: 'Huoltamon nimi',
        mileage: 'Ajokilometrit',
        controller_name: 'Ohjaimen nimi',
        function_name: 'Toiminto',
        time: 'Aika',
        function_execution_result: 'Toiminnon suoritustulos',
        channel: 'Kanava',
        hardware_number: 'Laitenro',
        written_software_information: 'Kirjoitettu ohjelmistotieto',
        software_information_before_refresh: 'Ohjelmistotieto ennen päivitystä',
        updated_software_information: 'Päivitetty ohjelmistotieto',
    },
    // 繁体中文台湾
    zhTW: {
        vin: 'VIN',
        name_of_maintenance_station: '維修站名稱',
        mileage: '里程數',
        controller_name: '控制器名稱',
        function_name: '功能',
        time: '時間',
        function_execution_result: '功能執行結果',
        channel: '通道',
        hardware_number: '硬體號',
        written_software_information: '寫入的軟體資訊',
        software_information_before_refresh: '刷新前的軟體資訊',
        updated_software_information: '刷新後的軟體資訊',
    },
    // 克罗地亚
    hrHR: {
        vin: 'VIN',
        name_of_maintenance_station: 'Naziv servisne stanice',
        mileage: 'Prijeđeni kilometri',
        controller_name: 'Naziv kontrolera',
        function_name: 'Funkcija',
        time: 'Vrijeme',
        function_execution_result: 'Rezultat izvršenja funkcije',
        channel: 'Kanal',
        hardware_number: 'Hardverski broj',
        written_software_information: 'Zapisane informacije o softveru',
        software_information_before_refresh: 'Informacije o softveru prije osvježenja',
        updated_software_information: 'Ažurirane informacije o softveru',
    },
    // 拉脱维亚
    lvLV: {
        vin: 'VIN',
        name_of_maintenance_station: 'Remontstacijas nosaukums',
        mileage: 'Nobraukums',
        controller_name: 'Kontrolētāja nosaukums',
        function_name: 'Funkcija',
        time: 'Laiks',
        function_execution_result: 'Funkcijas izpildes rezultāts',
        channel: 'Kanāls',
        hardware_number: 'Aparatūras numurs',
        written_software_information: 'Ierakstītā programmatūras informācija',
        software_information_before_refresh: 'Programmatūras informācija pirms atjaunošanas',
        updated_software_information: 'Atjauninātā programmatūras informācija',
    },
    // 立陶宛
    ltLT: {
        vin: 'VIN',
        name_of_maintenance_station: 'Techninės priežiūros stoties pavadinimas',
        mileage: 'Rida',
        controller_name: 'Valdiklio pavadinimas',
        function_name: 'Funkcija',
        time: 'Laikas',
        function_execution_result: 'Funkcijos vykdymo rezultatas',
        channel: 'Kanalas',
        hardware_number: 'Aparatinės įrangos numeris',
        written_software_information: 'Įrašyta programinės įrangos informacija',
        software_information_before_refresh: 'Programinės įrangos informacija prieš atnaujinimą',
        updated_software_information: 'Atnaujinta programinės įrangos informacija',
    },
    // 罗马尼亚
    roRO: {
        vin: 'VIN',
        name_of_maintenance_station: 'Numele stației de service',
        mileage: 'Kilometraj',
        controller_name: 'Numele controlerului',
        function_name: 'Funcție',
        time: 'Timp',
        function_execution_result: 'Rezultatul execuției funcției',
        channel: 'Canal',
        hardware_number: 'Număr hardware',
        written_software_information: 'Informații software scrise',
        software_information_before_refresh: 'Informații software înainte de actualizare',
        updated_software_information: 'Informații software actualizate',
    },
    // 挪威博克马尔
    nbNO: {
        vin: 'VIN',
        name_of_maintenance_station: 'Vedlikeholdsstedets navn',
        mileage: 'Kilometerstand',
        controller_name: 'Kontrollernavn',
        function_name: 'Funksjon',
        time: 'Tid',
        function_execution_result: 'Resultat av funksjonsutførelse',
        channel: 'Kanal',
        hardware_number: 'Maskinvarenr.',
        written_software_information: 'Innskrevet programvareinformasjon',
        software_information_before_refresh: 'Programvareinformasjon før oppdatering',
        updated_software_information: 'Oppdatert programvareinformasjon',
    },
    // 葡萄牙语巴西
    ptBX: {
        vin: 'VIN',
        name_of_maintenance_station: 'Nome da oficina',
        mileage: 'Quilometragem',
        controller_name: 'Nome do controlador',
        function_name: 'Função',
        time: 'Tempo',
        function_execution_result: 'Resultado da execução da função',
        channel: 'Canal',
        hardware_number: 'Número do hardware',
        written_software_information: 'Informações do software gravadas',
        software_information_before_refresh: 'Informações do software antes da atualização',
        updated_software_information: 'Informações do software atualizadas',
    },
    // 瑞典语
    svSE: {
        vin: 'VIN',
        name_of_maintenance_station: 'Verkstadens namn',
        mileage: 'Mätarställning',
        controller_name: 'Styrenhetsnamn',
        function_name: 'Funktion',
        time: 'Tid',
        function_execution_result: 'Resultat av funktionskörning',
        channel: 'Kanal',
        hardware_number: 'Hårdvarunummer',
        written_software_information: 'Inskriven programvaruinformation',
        software_information_before_refresh: 'Programvaruinformation före uppdatering',
        updated_software_information: 'Uppdaterad programvaruinformation',
    },
    // 斯洛伐克
    skSK: {
        vin: 'VIN',
        name_of_maintenance_station: 'Názov servisnej stanice',
        mileage: 'Najazdené km',
        controller_name: 'Názov riadiacej jednotky',
        function_name: 'Funkcia',
        time: 'Čas',
        function_execution_result: 'Výsledok vykonania funkcie',
        channel: 'Kanál',
        hardware_number: 'Hardvérové číslo',
        written_software_information: 'Zapísané informácie o softvéri',
        software_information_before_refresh: 'Informácie o softvéri pred aktualizáciou',
        updated_software_information: 'Aktualizované informácie o softvéri',
    },
    // 斯洛文尼亚
    slSI: {
        vin: 'VIN',
        name_of_maintenance_station: 'Ime servisne postaje',
        mileage: 'Prevoženi kilometri',
        controller_name: 'Ime krmilnika',
        function_name: 'Funkcija',
        time: 'Čas',
        function_execution_result: 'Rezultat izvedbe funkcije',
        channel: 'Kanal',
        hardware_number: 'Številka strojne opreme',
        written_software_information: 'Zapisane programske informacije',
        software_information_before_refresh: 'Programske informacije pred osvežitvijo',
        updated_software_information: 'Osvežene programske informacije',
    },
    // 泰语
    thTH: {
        vin: 'VIN',
        name_of_maintenance_station: 'ชื่อสถานีซ่อมบำรุง',
        mileage: 'เลขไมล์',
        controller_name: 'ชื่อคอนโทรลเลอร์',
        function_name: 'ฟังก์ชัน',
        time: 'เวลา',
        function_execution_result: 'ผลลัพธ์การดำเนินการฟังก์ชัน',
        channel: 'ช่องทาง',
        hardware_number: 'หมายเลขฮาร์ดแวร์',
        written_software_information: 'ข้อมูลซอฟต์แวร์ที่เขียน',
        software_information_before_refresh: 'ข้อมูลซอฟต์แวร์ก่อนรีเฟรช',
        updated_software_information: 'ข้อมูลซอฟต์แวร์หลังรีเฟรช',
    },
    // 乌克兰语
    ukUA: {
        vin: 'VIN',
        name_of_maintenance_station: 'Назва станції технічного обслуговування',
        mileage: 'Пробіг',
        controller_name: 'Назва контролера',
        function_name: 'Функція',
        time: 'Час',
        function_execution_result: 'Результат виконання функції',
        channel: 'Канал',
        hardware_number: 'Апаратний номер',
        written_software_information: 'Записана інформація про програмне забезпечення',
        software_information_before_refresh: 'Інформація про ПЗ до оновлення',
        updated_software_information: 'Оновлена інформація про програмне забезпечення',
    },
    // 希腊语
    elGR: {
        vin: 'VIN',
        name_of_maintenance_station: 'Όνομα σταθμού συντήρησης',
        mileage: 'Χιλιομετρική ένδειξη',
        controller_name: 'Όνομα ελεγκτή',
        function_name: 'Λειτουργία',
        time: 'Ώρα',
        function_execution_result: 'Αποτέλεσμα εκτέλεσης λειτουργίας',
        channel: 'Κανάλι',
        hardware_number: 'Αριθμός υλικού',
        written_software_information: 'Πληροφορίες λογισμικού που εγγράφηκαν',
        software_information_before_refresh: 'Πληροφορίες λογισμικού πριν την ανανέωση',
        updated_software_information: 'Ενημερωμένες πληροφορίες λογισμικού',
    },
    // 爱沙尼亚
    etEE: {
        vin: 'VIN',
        name_of_maintenance_station: 'Hooldusjaama nimi',
        mileage: 'Sõidukilomeetrid',
        controller_name: 'Juhtseadme nimi',
        function_name: 'Funktsioon',
        time: 'Aeg',
        function_execution_result: 'Funktsiooni käivitamise tulemus',
        channel: 'Kanal',
        hardware_number: 'Riistvara number',
        written_software_information: 'Kirjutatud tarkvarateave',
        software_information_before_refresh: 'Tarkvarateave enne värskendamist',
        updated_software_information: 'Värskendatud tarkvarateave',
    },
    // 哈萨克
    kkKZ: {
        vin: 'VIN',
        name_of_maintenance_station: 'Техникалық қызмет көрсету орнының атауы',
        mileage: 'Жүрілген жол',
        controller_name: 'Басқарғыштың атауы',
        function_name: 'Функция',
        time: 'Уақыт',
        function_execution_result: 'Функцияны орындау нәтижесі',
        channel: 'Арна',
        hardware_number: 'Құрылғы нөмірі',
        written_software_information: 'Жазылған бағдарламалық ақпарат',
        software_information_before_refresh: 'Жаңарту алдындағы бағдарламалық ақпарат',
        updated_software_information: 'Жаңартылған бағдарламалық ақпарат',
    },
    // 希伯来语
    heIL: {
        vin: 'VIN',
        name_of_maintenance_station: 'שם תחנת השירות',
        mileage: 'קילומטראז\'',
        controller_name: 'שם הבקר',
        function_name: 'פונקציה',
        time: 'זמן',
        function_execution_result: 'תוצאות ביצוע הפונקציה',
        channel: 'ערוץ',
        hardware_number: 'מספר חומרה',
        written_software_information: 'מידע על התוכנה שנכתב',
        software_information_before_refresh: 'מידע על התוכנה לפני רענון',
        updated_software_information: 'מידע על התוכנה לאחר רענון',
    },
};
